import { action, computed, makeAutoObservable } from 'mobx';
import { FiltersType } from 'src/components/GlobalPageV2/GlobalPageV2.types';

export class FilterState {
    public filters: Array<FiltersType>;
    public activeFilter;

    public constructor(filters: Array<FiltersType>, activeItem: string) {
        this.filters = filters;
        this.activeFilter = activeItem;
        makeAutoObservable(this);
    }

    @action public setActiveItem = (active: string): void => {
        this.activeFilter = active;
    };

    @computed public get activeItem(): string {
        return this.activeFilter;
    }
}
